<template>
    <div>
        <div class="row">
            <div class="col-12">
                <RegisterForm v-if="programme" v-bind="programme" entity="programme"  @on-pool="gotParticipants" :withSubmit="false"></RegisterForm>
            </div>
            <div class="col-12" v-if="barChart" >
                <card class="card-chart" no-footer-line>
                    <template slot="header">
                        <h5 class="card-category">Eventwise Enrollment Count</h5>
                        <h4 class="card-title">Registration Status</h4>
                    </template>
                    <div class="chart-area">
                        <bar-chart v-if="barChart" :key="keyValue"
                            :labels="barChart.labels"
                            :data="barChart.data"
                            :color="barChart.color"
                            :title="barChart.title"
                            :height="200">
                        </bar-chart>
                    </div>
                    <div slot="footer" class="stats">
                        <div class="pull-left">
                            <i class="now-ui-icons ui-2_time-alarm"></i> Last updated: {{ last_updated_time }}
                        </div>
                        <div class="pull-right" @click="reload()" style="cursor:pointer;">
                            <i class="now-ui-icons arrows-1_refresh-69"></i> Click to Refresh
                        </div>
                    </div>
                </card>
            </div>
            
        </div>
        <div class="row justify-content-start" v-if="programme">
            <div class="col-12" v-for="(event, index) in programme.events" :key="index">
                <PreviewCard v-bind="event" entity="event" cardType="long" :showBtn="true" v-on:card-click="onCardClick"></PreviewCard>
            </div>
        </div>
        <div class="row" v-if="false">
            <div class="col-md-6">
                <card class="card-chart" no-footer-line>
                    <template slot="header">
                        <h5 class="card-category">Simple With Grids And Numbers</h5>
                        <h4 class="card-title">Doughnut Chart</h4>
                    </template>
                    <div class="chart-area">
                        <doughnut-chart :labels="doughnutChart.labels"
                                :datasets="doughnutChart.datasets"
                                :height="200">
                        </doughnut-chart>
                    </div>
                    <div slot="footer" class="stats">
                        
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { PreviewCard, PreviewForm, RegisterForm } from 'src/components'
import BarChart from 'src/components/Charts/BarChart';
import DoughnutChart from 'src/components/Charts/DoughnutChart';

import { mapGetters } from 'vuex';

export default {
    components: {
        PreviewCard,
        PreviewForm,
        RegisterForm,
        BarChart,
        DoughnutChart
    },
    computed: {
        ...mapGetters({
            programme: 'getProgramme',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
        barChart(){
            let ret = {}
            if(this.programme){
                // https://stackoverflow.com/a/35431710/7664495
                // push returns the new length of the array.
                // What you need is the initially provided array.
                // therefor imp to return the acc ~ array
                ret.labels = this.programme.events.reduce((acc, { title }) => { acc.push(title); return acc; }, [])
                ret.data = this.programme.events.reduce((acc, { seating }) => { acc.push(seating.current_seat); return acc; }, [])
                ret.color = '#2CA8FF',
                ret.title = 'Registration Status'
                return ret;

            }
            else return null;
        },
        keyValue(){
            if(this.programme){
                return this.programme.seating.current_seat
            }
            return 0;
        }
        
    },
    mounted() {
        this.$store.commit('setProgramme', null)
        // this.$store.dispatch('getProgrammesData');
        this.$store.dispatch('getProgramme', this.$route.params.slug);
        this.last_updated()
    },
    methods: {
        gotParticipants(pool){
            // Note:- Work around for this.programme.participants_pool = pool
            // Vue is not reactive for such changes
            // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
            // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
            // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
            this.$set(this.programme, 'participants_pool', pool)
        },
        last_updated(){
            var d = new Date();
            var options =  { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            this.last_updated_time = d.toLocaleDateString('en-US', options); 
        },
        reload(){
            this.$store.dispatch('getProgramme', this.$route.params.slug);
            this.last_updated()
        },
        onCardClick(link){
            this.$router.push(`/registrations/view/event/${link}`)
        }
    },
    data() {
        return {
            last_updated_time: null,
            barChart1: {
                labels: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
                ],
                data: [80, 99, 86, 96, 123, 85, 100, 75, 88, 90, 123, 155],
                color: '#2CA8FF',
                title: 'Active Countries'
            },
            doughnutChart: {
                labels: ['Mathematics', 'English', 'Science', 'Islamic Studies'],
                datasets: [
                {
                    backgroundColor: [
                    '#41B883',
                    '#E46651',
                    '#00D8FF',
                    '#DD1B16'
                    ],
                    data: [40, 20, 80, 10]
                }
                ]
            },
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

